module.exports = __webpack_public_path__ + "img/snake-v2-blue.c5055f7e.svg";